import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AppService, CommonCloudstudioService, ReplaceLiteralsPipe } from 'common-cloudstudio';
import { GearAppService } from 'common-gear';
import { IncidentsComponent } from './incidents/incidents.component';
import { Subscription } from 'rxjs';
import moment from 'moment';


@Component({
  selector: 'app-incident-management',
  templateUrl: './incident-management.component.html',
  styleUrls: ['./incident-management.component.scss']
})

export class IncidentManagementComponent implements OnInit, OnDestroy {
  @ViewChild('incidents') private _incidents: IncidentsComponent;

  _errorBackEnd: string = "";
  activeTab: number = 1;

  shiftsGeneralActions = [
    { Icon: 'fa-solid fa-magnifying-glass', Tooltip: 'Ver turno', Action: (row) => this.onEdit(row) },
    { Icon: 'fa-solid fa-user-plus', Tooltip: 'Detalles', Action: (row) => this.onDetails(row) },
    { Icon: 'fa-solid fa-xmark', Tooltip: 'Eliminar', Action: (row) => this.onDelete(row) },
  ]

  generalActions = [
    { Icon: 'fa-solid fa-magnifying-glass', Tooltip: 'Ver registro', Action: (row) => this.onEdit(row) },
  ]

  shiftsTableData = {
    Columns: [
      { Title: 'ID', Field: 'ElementId', Type: 'text' },
      { Title: 'Turno', Field: 'Shift', Type: 'text' },
      { Title: 'Usuario inicio', Field: 'UserStart', Type: 'text' },
      { Title: 'Usuario inicio', Field: 'UserEnd', Type: 'text' },
      { Title: 'Fecha inicio', Field: 'DateTimeStart', Type: 'text' },
      { Title: 'Fecha fin', Field: 'DateTimeEnd', Type: 'text' },
      { Title: 'Observaciones', Field: 'Observations', Type: 'text'},
      { Title: '', Field: 'Actions', Type: 'actions' }
    ],
    Elements: [
      {
        ElementId: 189,
        Shift: 'Turno noche',
        UserStart: 'Erick González',
        UserEnd: '',
        DateTimeStart: moment(new Date()).format('DD-MM-YYYY ') + ' 20:00',
        DateTimeEnd: moment(new Date()).format('DD-MM-YYYY ') + ' 07:59',
        Observations: '',
        Actions: this.shiftsGeneralActions,
      },
      {
        ElementId: 188,
        Shift: 'Turno día',
        UserStart: 'Camila Yañez',
        UserEnd: '',
        DateTimeStart: moment(new Date()).format('DD-MM-YYYY ') + ' 08:00',
        DateTimeEnd: moment(new Date()).format('DD-MM-YYYY ') + ' 19:59',
        Observations: '',
        Actions: this.shiftsGeneralActions,
      },
      {
        ElementId: 187,
        Shift: 'Turno noche',
        UserStart: 'Erick González',
        UserEnd: '',
        DateTimeStart: moment(new Date()).format('DD-MM-YYYY ') + ' 20:00',
        DateTimeEnd: moment(new Date()).format('DD-MM-YYYY ') + ' 07:59',
        Observations: '',
        Actions: this.shiftsGeneralActions,
      },
      {
        ElementId: 186,
        Shift: 'Turno día',
        UserStart: 'Camila Yañez',
        UserEnd: '',
        DateTimeStart: moment(new Date()).format('DD-MM-YYYY ') + ' 08:00',
        DateTimeEnd:  moment(new Date()).format('DD-MM-YYYY ') + ' 19:59',
        Observations: '',
        Actions: this.shiftsGeneralActions
      },
    ]
  };
  subscriptions: Subscription[] = [];
  generalLiteral: string = ''
  langPlatform: string = 'ES_AR';

  constructor(
    public _appService: AppService,
    public _gearAppService: GearAppService,
    private replaceLiterals: ReplaceLiteralsPipe,
    public commonService: CommonCloudstudioService
  ) {}

  ngOnInit(): void { }

  ngOnDestroy(): void {
   this.subscriptions.forEach(s => s.unsubscribe());
  }

  onEdit(id) {}

  onDelete(id) {}

  onDetails(id) {}
}
